import { Component, OnInit } from '@angular/core';
import { CadastroDocumentosUpload } from '../../../../../shared/components/cadastros-documentos-upload/cadastros-documentos-upload.component';

@Component({
  templateUrl: 'comprovante-renda-upload.page.html',
  styleUrls: ['comprovante-renda-upload.page.scss'],
})
export class ComprovanteRendaAssinaturaPage extends CadastroDocumentosUpload implements OnInit {

  ngOnInit(): void {
    this.carregarDadosDaRota().subscribe();
  }

  protected navegarParaProxima(): void {
    this.router.navigate(['../../confirmar-informacoes'], { relativeTo: this.route });
  }
}
